import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getEntity, deleteEntity } from './content.reducer';

export const ContentDeleteDialog = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();
  const { id } = useParams<'id'>();

  const [loadModal, setLoadModal] = useState(false);

  useEffect(() => {
    dispatch(getEntity(id));
    setLoadModal(true);
  }, []);

  const contentEntity = useAppSelector(state => state.content.entity);
  const updateSuccess = useAppSelector(state => state.content.updateSuccess);

  const handleClose = () => {
    navigate('/content' + pageLocation.search);
  };

  useEffect(() => {
    if (updateSuccess && loadModal) {
      handleClose();
      setLoadModal(false);
    }
  }, [updateSuccess]);

  const confirmDelete = () => {
    dispatch(deleteEntity(contentEntity.id));
  };

  return (
    <Dialog open onClose={handleClose} PaperProps={{ sx: { minWidth: 400 } }}>
      <DialogTitle id="contentDeleteDialogHeading" sx={{ fontWeight: 600 }}>
        <Translate contentKey="entity.delete.title">Confirm delete operation</Translate>
      </DialogTitle>
      <DialogContent>
        <Translate contentKey="jhipsterSampleApplicationApp.content.delete.question" interpolate={{ id: contentEntity.id }}>
          Are you sure you want to delete this Content?
        </Translate>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="inherit">
          <FontAwesomeIcon icon="ban" />
          &nbsp;
          <Translate contentKey="entity.action.cancel">Cancel</Translate>
        </Button>
        <Button id="jhi-confirm-delete-content" data-cy="entityConfirmDeleteButton" onClick={confirmDelete} color="error">
          <FontAwesomeIcon icon="trash" />
          &nbsp;
          <Translate contentKey="entity.action.delete">Delete</Translate>
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ContentDeleteDialog;
